export default "__VITE_ASSET__DGKinuHj__"